import { scaleOpacity } from '@dynamic/ui';
import styled from 'styled-components';

interface FillDivProps {
  backgroundColor?: string;
  backgroundImage?: string;
  color?: string;
  opacity?: number;
}

/** Absolute positioned div covering its parent */
export const FillDiv = styled.div<FillDivProps>`
  position: absolute;
  inset: 0;
  ${({ backgroundColor, opacity }) =>
    backgroundColor &&
    `background-color: ${
      opacity ? scaleOpacity(backgroundColor, opacity) : backgroundColor
    };`}
  ${({ backgroundImage }) =>
    backgroundImage &&
    `background: url('${backgroundImage}') center center / 100% 100%;`}
    ${({ color }) => color && `color: ${color};`}
`;

FillDiv.displayName = 'FillDiv';
